module.exports = __webpack_public_path__ + "static/media/mob-paintathon-main.a0c0d32d.jpg";